import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils' // Separate module needed to allow the router serve it

// @see app/server/utils/loadModules.js
import CrosssellSlider from './CrosssellSlider'

const SliderProxy = props => {
  let { className, showBuyButton, ...cleanProps } = props
  const { adServerSideContext: adServerContext } = usePageProperties()

  return (
    <CrosssellSlider
      {...{
        ...cleanProps,
        adServerContext,
        showBuyButton,
        className,
      }}
    />
  )
}

SliderProxy.propTypes = CrosssellSlider.propTypes
SliderProxy.defaultProps = CrosssellSlider.defaultProps

export default SliderProxy
